import { createRoot } from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';

import { SessionProvider } from '@contexts/SessionProvider';
import { UserProvider } from '@contexts/UserProvider.tsx';
import { TokenProvider } from '@contexts/TokenProvider.tsx';
import { PreferencesProvider } from '@contexts/PreferencesProvider.tsx';
import { setDocumentTitle } from '@utils/shared';

import App from './App.tsx';

import './index.css';

// Set document title based on environment (e.g., "[dev] Design Draft" for lower envs)
setDocumentTitle();

createRoot(document.getElementById('root')!).render(
    <TokenProvider>
        <UserProvider>
            <SessionProvider>
                <PreferencesProvider>
                    <App />
                </PreferencesProvider>
            </SessionProvider>
        </UserProvider>
    </TokenProvider>
);
